<template>
  <div v-if="quick_videos&&quick_videos.videos.length>=1">
      <div v-if="quick_videos.videos.length==1" class="single-file">
          <QuickVideoPlayer :video="quick_videos.videos[0]" />
      </div>
      <div v-if="quick_videos.videos.length>1" class="video-list" :style="{'grid-template-columns': quick_videos.list_mode==1?'repeat(1,1fr)':'repeat(2,1fr)'}">
          <div v-for="(video, index) in quick_videos.videos" :key="video.id" class="video" @click="playVideo(index)">
              <img :src="videoCover(video)" style="width:100%" />
              <img src="@/assets/icons/video_play.png" class="video-play-icon" />
          </div>
      </div>
  </div>
</template>

<script>
import QuickVideoPlayer from './QuickVideoPlayer.vue';

export default {
  name: 'QuickVideo',
  components: {
    QuickVideoPlayer
  },
  data(){
    return {

    }
  },
  props: {
    quick_videos: null
  },
  methods:{
    videoCover(video){

      if(!video)
        return '';

      const jsonMisc=JSON.parse(video.misc);

      return jsonMisc.cover;

    },
    playVideo(index){

      this.$router.push({name:'video-play', query:{index:index}});

    }
  },
  created(){
    
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.single-file{
  position: relative;
}
.video-list{
  padding:30px 0px;
  overflow-y: scroll;
  display: grid;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.video-list .video{
  position: relative;
}
.video-play-icon{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width:20%;
}
</style>